import { Component } from '@angular/core';

@Component({ templateUrl: 'dashboard.page.html' })
export class DashboardPage {}
